import styled from 'styled-components';

export const FilterBasicTogglerContainer = styled.div`
  align-items: center;
  display: flex;
  padding-right: 1rem;
  justify-content: space-between;
  width: 100%;
`;

export const FilterBasicTogglerTitle = styled.div`
  color: ${(props): string => props.theme.filters.color};
  font-size: 1.125rem;
  font-weight: 600;
`;
